var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tagName,_vm._b({tag:"component",staticClass:"text-center cell",class:{
    'text-danger': _vm.isNegative(_vm.value)
  }},'component',_vm.$attrs,false),[_vm._v("\n  "+_vm._s(_vm.formatCurrency(_vm.value))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }